import { render } from "./regionalAgent.vue?vue&type=template&id=d1d6a6d4&scoped=true"
import script from "./regionalAgent.vue?vue&type=script&lang=js"
export * from "./regionalAgent.vue?vue&type=script&lang=js"

import "./regionalAgent.vue?vue&type=style&index=0&id=d1d6a6d4&lang=less&scoped=true"
import "./regionalAgent.vue?vue&type=style&index=1&id=d1d6a6d4&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1d6a6d4"]])

export default __exports__